import { render, staticRenderFns } from "./ResendConfirmation.vue?vue&type=template&id=9a384520"
import script from "./ResendConfirmation.vue?vue&type=script&lang=js"
export * from "./ResendConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports